import { useTranslation } from 'react-i18next';
import ProductSearchCard from '../PublicCatalog/ProductSearchCard';
import './ProductSearchSection.scss';

// Landing page section: public medicine search (name / DCI, barcode) leading to the
// /{lang}/medicaments results and the public product pages — the same search card as under a
// public product page, with the landing's translated texts.
const ProductSearchSection = () => {
    const { t, i18n } = useTranslation();
    return (
        <section className="syd-search" id="medicaments">
            <div className="container">
                <ProductSearchCard
                    lang={i18n.language}
                    title={t('catalog.landing.title')}
                    subtitle={t('catalog.landing.subtitle')}
                    placeholder={t('catalog.landing.placeholder')}
                    submitLabel={t('catalog.search.submit')}
                    scanLabel={t('catalog.search.scan')}
                    popularLabel={t('catalog.landing.popular')}
                    browseLabel={t('catalog.landing.browse')}
                />
            </div>
        </section>
    );
};

export default ProductSearchSection;
